import { ColumnSource, RowSource } from "@omegagrid/grid";
import { ColorTypes } from "@omegagrid/core";
import { msg } from "@omegagrid/localize";
import rp, { GridEditorAdapter, GridEditorOptions, RowData } from "@reporting/rp-app-host";
import { ModuleCode } from "@reporting/rp-types/accounting";
import { DrillColumnDefinition } from "@reporting/rp-types/definition";

export class DrillColumnsGridEditorAdapter extends GridEditorAdapter {

	private _columns: ColumnSource[];

	constructor (
		private moduleCode: ModuleCode,
	) { super() }

	async getColumns(): Promise<ColumnSource[]> {
		if (this._columns) return this._columns;
		this._columns = [{
			data: 'name',
			header: msg('Column'),
			t: 't',
			e: false,
			w: 200
		}, {
			data: 'description',
			header: msg('Name'),
			t: 't',
			e: false,
			w: 300
		}, {
			data: 'hidden',
			header: msg('Hidden'),
			t: 'b',
			e: true,
			w: 80
		}, {
			data: 'ord',
			header: msg('Order'),
			t: 'n',
			e: true,
			w: 80
		}];
		return this._columns;
	}

	async getRows(): Promise<RowSource[]> {
		const columns = await rp.ms('definition').get<DrillColumnDefinition[]>(`drillColumns/${this.moduleCode}`);
		return columns.map(data => ({ data: {
			ord: data.ord,
			name: data.name,
			description: msg(data.description),
			hidden: data.hidden,
		}}));
	}

	getOptions(): Partial<GridEditorOptions> {
		return this.createOptions({
			colLetters: false,
			columnSorting: true,
			refreshAfterSave: true,
			saveMode: 'all_rows',
			toolbar: {
				new: {enabled: false},
			},
			pageSize: null,
		});
	}

	async save(rowData: RowData[]) {
		const data = rowData.map(({ data: { name, hidden, ord } }) => ({ name, hidden, ord }));
		await rp.ms('definition').post(`drillColumns/${this.moduleCode}`, data);
	}

}
